import { Icon } from 'components/Icon'
import { IconName } from 'components/Icon/iconNames'
import { CircledIconRoot } from './CircledIcon.styles'

type CircledIconProps = {
  icon: IconName
}

export const CircledIcon = ({ icon }: CircledIconProps) => {
  return (
    <CircledIconRoot>
      <Icon name={icon} size="6" />
    </CircledIconRoot>
  )
}
